// extracted by mini-css-extract-plugin
export default {"headingYellow":"DeleteESIMNotification_headingYellow__d9cIx"};